module.exports = __webpack_public_path__ + "img/kv-pc.e1e4c12.jpg";